document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#quote-form-india");
  if (!form) return;

  const ZAP_URL = "https://services.leadconnectorhq.com/hooks/3SsfTbU1lmAPpkG9iB6C/webhook-trigger/fe078586-dee7-411d-a5d0-7dec01009231";

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries());

    if (!data.wa_optin) {
      alert("Please agree to WhatsApp contact.");
      return;
    }

    try {
      const res = await fetch(ZAP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        form.reset();
        const msg = form.querySelector("#form-status");
        if (msg) msg.style.display = "block";
      } else {
        alert("Submit failed, please try again.");
      }
    } catch (err) {
      alert("Network error, please try again.");
    }
  });
});
